import Slot from 'models/Slot'

const getObject = (slot) => new Slot(slot.name, slot.description, slot.isPrivate, slot.group, slot.fees, slot.times)

export default getObject
